module.exports = __webpack_public_path__ + "static/media/Nazca-textura.1b6a2d73.png";